// extracted by mini-css-extract-plugin
module.exports = {"bm-section":"bm-section","content-overview-section":"content-overview-section","soccer-content-item":"soccer-content-item"};